// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// Wholesale Price Update Handler
// This intercepts price updates to apply wholesale pricing
// ================================================================================
(function() {
  'use strict';
  
  // Function to get wholesale price from Product JSON
  function getWholesalePrice(variantId) {
    try {
      var productJsonScript = document.querySelector('script[id^="ProductJson-"]');
      if (!productJsonScript) {
        return null;
      }
      
      var productData = JSON.parse(productJsonScript.textContent);
      if (!productData || !productData.variants) {
        return null;
      }
      
      var wholesaleVariant = productData.variants.find(function(v) {
        return v.id === variantId;
      });
      
      return wholesaleVariant;
    } catch (e) {
      return null;
    }
  }
  
  // Function to update prices with wholesale pricing
  function updatePricesWithWholesale() {
    var priceElements = document.querySelectorAll('[data-price]');
    if (priceElements.length === 0) {
      return;
    }
    
    // Get current variant ID from the page
    var currentVariantId = null;
    var variantSelect = document.querySelector('[data-variant-select]');
    if (variantSelect) {
      var selectedOption = variantSelect.querySelector('option:checked');
      if (selectedOption) {
        currentVariantId = parseInt(selectedOption.value);
      }
    }
    
    // Also check data attribute
    var productContainer = document.querySelector('[data-product-id]');
    if (!currentVariantId && productContainer) {
      currentVariantId = parseInt(productContainer.dataset.currentProductId);
    }
    
    if (!currentVariantId) {
      return;
    }
    
    var wholesaleVariant = getWholesalePrice(currentVariantId);
    if (!wholesaleVariant) {
      return;
    }
    
    // Format money helper
    function formatPrice(cents) {
      if (typeof formatMoney !== 'undefined') {
        return formatMoney(cents);
      }
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || "${{amount}}");
      }
      var amount = (cents / 100).toFixed(2);
      return '$' + amount;
    }
    
    // Check if prices need updating
    var needsUpdate = false;
    priceElements.forEach(function(el) {
      var currentText = el.textContent.trim();
      var wholesaleText = formatPrice(wholesaleVariant.price);
      if (currentText !== wholesaleText) {
        needsUpdate = true;
      }
    });
    
    if (needsUpdate) {
      priceElements.forEach(function(el) {
        el.innerHTML = formatPrice(wholesaleVariant.price);
      });
      
      // Update compare prices
      var comparePriceElements = document.querySelectorAll('[data-compare-price]');
      comparePriceElements.forEach(function(el) {
        if (wholesaleVariant.compare_at_price && wholesaleVariant.compare_at_price > wholesaleVariant.price) {
          el.innerHTML = formatPrice(wholesaleVariant.compare_at_price);
        } else {
          el.innerHTML = '';
        }
      });
    }
  }
  
  // Use MutationObserver to watch for price changes
  function setupPriceObserver() {
    var priceContainer = document.querySelector('.product__price-and-ratings, .product__block--product-header');
    if (!priceContainer) {
      setTimeout(setupPriceObserver, 500);
      return;
    }
    
    var observer = new MutationObserver(function(mutations) {
      var shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          var target = mutation.target;
          if (target.matches && (target.matches('[data-price]') || target.closest('[data-price]'))) {
            shouldUpdate = true;
          }
        }
      });
      
      if (shouldUpdate) {
        // Wait a bit for the update to complete, then apply wholesale pricing
        setTimeout(updatePricesWithWholesale, 50);
      }
    });
    
    observer.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
    
    // Also run immediately
    setTimeout(updatePricesWithWholesale, 100);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(setupPriceObserver, 500);
    });
  } else {
    setTimeout(setupPriceObserver, 500);
  }
})(); // End of IIFE

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  // Update prices with wholesale pricing if available (backup method)
  var variant = evt.detail.variant;
  if (!variant) {
    return;
  }
  
  // Find the product JSON script tag
  var productJsonScript = document.querySelector('script[id^="ProductJson-"]');
  if (!productJsonScript) {
    return;
  }
  
  try {
    var productData = JSON.parse(productJsonScript.textContent);
    if (!productData || !productData.variants) {
      return;
    }
    
    // Find the matching variant in the product data (which has wholesale prices)
    var wholesaleVariant = productData.variants.find(function(v) {
      return v.id === variant.id;
    });
    
    if (!wholesaleVariant) {
      return;
    }
    
    // Update all price elements with wholesale price
    var priceElements = document.querySelectorAll('[data-price]');
    var comparePriceElements = document.querySelectorAll('[data-compare-price]');
    
    // Helper to format money
    function formatPrice(cents) {
      if (typeof formatMoney !== 'undefined') {
        return formatMoney(cents);
      }
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || "${{amount}}");
      }
      var amount = (cents / 100).toFixed(2);
      return '$' + amount;
    }
    
    // Update price
    priceElements.forEach(function(el) {
      el.innerHTML = formatPrice(wholesaleVariant.price);
    });
    
    // Update compare price
    comparePriceElements.forEach(function(el) {
      if (wholesaleVariant.compare_at_price && wholesaleVariant.compare_at_price > wholesaleVariant.price) {
        el.innerHTML = formatPrice(wholesaleVariant.compare_at_price);
      } else {
        el.innerHTML = '';
      }
    });
  } catch (e) {
    // Silently fail
  }
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});
/* eslint-enable no-console */
